import Link from "next/link";
import { useEffect, useState } from "react";

import { postFormData } from "../../core/fetch.core";
import { useTranslation } from "../../core/translation.core";
import FileDrop from "../form/fileDrop.comp";

type State = "init" | "uploading" | "completed" | "failed";

export default function ImportFullShop() {
  const { t, msg } = useTranslation();

  return (
    <section data-type="section" className="space-y-4">
      <h2>{t(msg.import.importWholeShop)}</h2>
      <Steps />
      <Content />
    </section>
  );
}

function Content() {
  const [status, setStatus] = useState<State>("init");
  const [rst, setRst] = useState(null);
  const [data, setData] = useState();

  useEffect(() => {
    if (data) {
      submit(data);
    }
  }, [data]);

  async function submit(data: Uint8Array) {
    if (data === null || data === undefined) return;

    setStatus("uploading");
    setRst(null);
    const formData = new FormData();
    formData.append("file", new File([data], "fullShop.json"));

    const rst = await postFormData<any>("/admin/import/fullShop", formData);
    setStatus("completed");
    setRst(rst.data);
  }

  if (status === "uploading") {
    return <div>Uploading...</div>;
  }

  if (status === "completed") {
    return (
      <>
        <div>Completed</div>
        <Result rst={rst} />
      </>
    );
  }

  return <FileDrop setData={setData} />;
}

// TODO:
// Import media files, category media association, banner
function Steps() {
  return (
    <div>
      <h2>
        This function is for migrating the shop from dev enviroment to production enviroment. Here is the detail instruction of
        copying the whole shop.
      </h2>
      <ol className="ml-4">
        <li>
          Export out the whole shop .json file in source environment, for example, in dev&nbsp;
          <Link className="underline font-bold" href="https://heradmin-dev.hishk.com/">
            https://heradmin-dev.hishk.com/
          </Link>
        </li>
        <li>
          Log in into the dest environment, for example,&nbsp;
          <Link className="underline font-bold" href="https://admin.hisher.hk/">
            https://admin.hisher.hk/
          </Link>
        </li>
        <li>Import the json file to load all data into the database.</li>
        <li>Go to AWS S3, copy over the shop bucket from source env to dest env.</li>
      </ol>
    </div>
  );
}

function Result({ rst }: { rst: any }) {
  if (!rst) return null;

  return (
    <table className="border-collapse border border-slate-500 mb-6">
      <tbody>
        {Object.entries(rst).map(([key, value]) => {
          return (
            <tr key={key}>
              <td>{key}</td>
              <td>{value as any}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
